import Cookie from 'js-cookie'

export const AdminMixin = {
  data () {
    return {
      smallTable: true
    }
  },
  methods: {
    getUserRole (roles) {
      this.userRoles = roles
      var systemRoles = ['SYSTEM TSAR', 'SYSTEM PIPELINE EXPERT', 'FRB ADMIN', 'FRB APPRENTICE']
      // var scienceRoles = ['MEMBER', 'TEAM LEADER', 'DATA QUALITY EXPERT', 'SCIENCE PIPELINE EXPERT']
      var higherRoles = ['PROJECT OFFICE', 'FRB COORDINATOR']
      this.userRole = 'SYSTEM TSAR'
      for (var r = 0; r < roles.length; r++) {
        if (systemRoles.includes(roles[r])) {
          this.userRole = roles[r]
        } else if (higherRoles.includes(roles[r])) {
          this.userRole = roles[r]
        }
      }
    },
    getUsers () {
      this.teamItems = {'1': [], '2': [], '3': [], '4': []}
      this.teamMembers = {'1': [], '2': [], '3': [], '4': []}
      this.roleItems = {
        'projectOffice': [],
        'frbCoordinator': [],
        'teamLeaders': [],
        'systempipelineExperts': [],
        'members': [],
        'sciencepipelineExperts': [],
        'dataqualityExperts': [],
        'systemTsars': [],
        'frbAdmin': [],
        'frbApprentice': []
      }
      this.form.options = [{ value: null, text: 'Please select an option' }]
      this.fetchTeams('1')
      this.fetchTeams('2')
      this.fetchTeams('3')
      this.fetchTeams('4')
      this.fetchRoles('PROJECT OFFICE')
      this.fetchRoles('FRB COORDINATOR')
      this.fetchRoles('SYSTEM PIPELINE EXPERT')
      this.fetchRoles('FRB ADMIN')
      this.fetchRoles('FRB APPRENTICE')
      this.fetchRoles('SCIENCE PIPELINE EXPERT')
      this.fetchRoles('DATA QUALITY EXPERT')
      this.fetchRoles('TEAM LEADER')
      this.fetchRoles('MEMBER')
      this.fetchRoles('SYSTEM TSAR')
    },
    getAnalysisEvents () {
      this.analysisSummaryItems = []
      this.refreshToken()
      var authHeaders = {'Authorization': localStorage.accessToken}
      this.$http.get(this.baseUrl + '/v1/analysis/events/user-save-count', {headers: authHeaders}, {responseType: 'json', timeout: 10000})
        .then(response => {
          this.parseAnalysisEvents(response.body)
        })
    },
    parseAnalysisEvents (events) {
      var users = Object.keys(events)
      var total = {'user': 'Total', '_rowVariant': 'danger'}
      for (var i = 0; i < users.length; i++) {
        var item = {}
        item['_rowVariant'] = 'info'
        item['user'] = users[i]
        var pipelines = Object.keys(events[users[i]])
        for (var j = 0; j < pipelines.length; j++) {
          item[pipelines[j]] = events[users[i]][pipelines[j]]
          if (Object.keys(total).includes(pipelines[j])) {
            total[pipelines[j]] = total[pipelines[j]] + item[pipelines[j]]
          } else {
            total[pipelines[j]] = item[pipelines[j]]
          }
        }
        this.analysisSummaryItems.push(item)
      }
      this.analysisSummaryItems.unshift(total)
      this.totalRows = this.analysisSummaryItems.length
    },
    fetchTeams (team) {
      var payload = {'team': team}
      var authHeaders = {'Authorization': localStorage.accessToken}
      this.$http.post(this.baseUrl + '/v1/admin/get-users', payload, {headers: authHeaders}, {responseType: 'json', timeout: 10000})
        .then(response => {
          this.parseTeams(response.body)
        })
    },
    fetchRoles (role) {
      var payload = {'role': role}
      var authHeaders = {'Authorization': localStorage.accessToken}
      this.$http.post(this.baseUrl + '/v1/admin/get-users', payload, {headers: authHeaders}, {responseType: 'json', timeout: 10000})
        .then(response => {
          this.parseExperts(response.body)
        })
    },
    parseExperts (users) {
      for (var i = 0; i < users.length; i++) {
        var skip = false
        for (var j = 0; j < Object.keys(this.roleItems).length; j++) {
          var role = this.roleItems[Object.keys(this.roleItems)[j]]
          for (var k = 0; k < role.length; k++) {
            var roleuser = role[k]
            for (var r = 0; r < Object.keys(roleuser).length; r++) {
              var finalkey = roleuser[Object.keys(roleuser)[r]]
              if (finalkey === users[i]['name']) {
                skip = true
              }
            }
          }
        }
        if (skip === true) {
          continue
        }
        var item = {}
        if (users[i]['roles'].includes('PROJECT OFFICE')) {
          item['_rowVariant'] = 'danger'
          item['PROJECT OFFICE'] = users[i]['name']
          this.roleItems['projectOffice'].push(item)
        }
        if (users[i]['roles'].includes('FRB COORDINATOR')) {
          item['_rowVariant'] = 'success'
          item['FRB Coordinator'] = users[i]['name']
          this.roleItems['frbCoordinator'].push(item)
        }
        item = {}
        if (users[i]['roles'].includes('SYSTEM PIPELINE EXPERT')) {
          item['_rowVariant'] = 'info'
          item['SYSTEM Pipeline Expert'] = users[i]['name']
          item['team'] = users[i]['team']
          this.roleItems['systempipelineExperts'].push(item)
        }
        if (users[i]['roles'].includes('FRB ADMIN')) {
          item['_rowVariant'] = 'info'
          item['FRB ADMIN'] = users[i]['name']
          item['team'] = users[i]['team']
          this.roleItems['frbAdmin'].push(item)
        }
        if (users[i]['roles'].includes('FRB APPRENTICE')) {
          item['_rowVariant'] = 'info'
          item['FRB APPRENTICE'] = users[i]['name']
          item['team'] = users[i]['team']
          this.roleItems['frbApprentice'].push(item)
        }
        if (users[i]['roles'].includes('SYSTEM TSAR')) {
          item['_rowVariant'] = 'primary'
          item['SYSTEM TSAR'] = users[i]['name']
          item['team'] = users[i]['team']
          this.roleItems['systemTsars'].push(item)
        }
        item = {}
        if (users[i]['roles'].includes('SCIENCE PIPELINE EXPERT')) {
          item['_rowVariant'] = 'info'
          item['SCIENCE Pipeline Expert'] = users[i]['name']
          item['team'] = users[i]['team']
          this.roleItems['sciencepipelineExperts'].push(item)
        }
        if (users[i]['roles'].includes('DATA QUALITY EXPERT')) {
          item['_rowVariant'] = 'info'
          item['DATA QUALITY Expert'] = users[i]['name']
          item['team'] = users[i]['team']
          this.roleItems['dataqualityExperts'].push(item)
        }
        if (users[i]['roles'].includes('TEAM LEADER')) {
          item['_rowVariant'] = 'warning'
          item['Team Leader'] = users[i]['name']
          item['team'] = users[i]['team']
          this.roleItems['teamLeaders'].push(item)
        }
        if (users[i]['roles'].includes('MEMBER')) {
          item['_rowVariant'] = 'primary'
          item['Member'] = users[i]['name']
          item['team'] = users[i]['team']
          this.roleItems['members'].push(item)
        }
        this.form.options.push({value: users[i]['name'], text: users[i]['name']})
      }
    },
    parseTeams (users) {
      for (var i = 0; i < users.length; i++) {
        var item = {}
        if (users[i]['team'] === '1') {
          item['_rowVariant'] = 'danger'
        } else if (users[i]['team'] === '2') {
          item['_rowVariant'] = 'success'
        } else if (users[i]['team'] === '4') {
          item['_rowVariant'] = 'warning'
        } else {
          item['_rowVariant'] = 'info'
        }
        item['name'] = users[i]['name']
        item['roles'] = ''
        for (var j = 0; j < users[i]['roles'].length; j++) {
          if (j === 0) {
            item['roles'] += users[i]['roles'][j]
          } else {
            item['roles'] += ', ' + users[i]['roles'][j]
          }
        }
        this.teamItems[users[i]['team']].push(item)
      }
    },
    onFiltered (filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    refreshToken () {
      Cookie.remove('access_token')
      if (localStorage.refreshToken && localStorage.accessToken && localStorage.username) {
        var url = this.baseUrl + 'auth/refresh'
        var authHeaders = {'Authorization': localStorage.accessToken}
        // var authHeaders = {'Authorization': localStorage.accessToken}
        var refreshPayload = {'refresh_token': localStorage.refreshToken}
        this.$http.post(url, refreshPayload, {headers: authHeaders})
          .then(user => {
            localStorage.accessToken = user.body.access_token
            localStorage.accessTime = Date.now() / 1000
          }, user => {
            this.$router.replace(this.$route.query.redirect || '/frb-web/login')
          })
      } else {
        this.$router.replace(this.$route.query.redirect || '/frb-web/login')
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/mixins/adminMixin.js